// Exporting a table (issue 1170): the DM's download of the table's scenes, boards, maps, pictures, sounds, rules and
// kept rulings as one ZIP. Asked for through `authFetch` (the bearer, refreshed once on a 401) — never a link the
// browser follows, since a picture or a sound is never at a public URL — and handed to the browser as a file.
import { authFetch } from './session';

/** What the Table menu's dialog says the archive holds. */
export const EXPORT_NOTE = "One .zip file with the table's scenes and everything on them, the maps, the pictures and sounds the table uses, its rules, the rulings you kept, and the table's history. Characters are exported from the site.";

/** `<table name> <date>.zip`, as the server names it. */
export const exportFileName = (tableName: string, now = new Date()) =>
  `${tableName.replace(/[\u0000-\u001f\u007f"\\/]+/g, ' ').replace(/\s+/g, ' ').trim() || 'Table'} ${now.toISOString().slice(0, 10)}.zip`;

/** Fetch the export and save it. True when saved; otherwise the server's words, or a sentence of our own. */
export async function downloadTable(campaignId: string, tableName: string, fetchImpl: typeof fetch = fetch, doc: Document = document): Promise<true | string> {
  const failed = "The table's export could not be downloaded just now.";
  try {
    const res = await authFetch(`/api/tables/${campaignId}/export`, {}, fetchImpl);
    if (!res.ok) {
      const body = await res.json().catch(() => null) as { reason?: unknown } | null;
      return typeof body?.reason === 'string' ? body.reason : failed;
    }
    const blob = await res.blob();
    const url = URL.createObjectURL(blob.type === 'application/zip' ? blob : new Blob([blob], { type: 'application/zip' }));
    const a = doc.createElement('a');
    a.href = url;
    a.download = exportFileName(tableName);
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    return true;
  } catch {
    return failed;
  }
}
